"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackOpenAiVoiceId = void 0;
exports.FallbackOpenAiVoiceId = {
    Alloy: "alloy",
    Echo: "echo",
    Fable: "fable",
    Onyx: "onyx",
    Nova: "nova",
    Shimmer: "shimmer",
    Ash: "ash",
    Ballad: "ballad",
    Coral: "coral",
    Sage: "sage",
    Verse: "verse",
};
